module.exports = __webpack_public_path__ + "img/blood-icon-large.68fe95df.webp";